/**
 * @generated SignedSource<<f9492297d3ee68695018811c75e30dc9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type customerLandingPageRelayQuery$variables = {
  locale: string;
};
export type customerLandingPageRelayQuery$data = {
  readonly customerStoryCollection: {
    readonly items: ReadonlyArray<{
      readonly advocateQuotesCollection: {
        readonly items: ReadonlyArray<{
          readonly advocateHeadshot: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly url: string | null | undefined;
          } | null | undefined;
          readonly advocateJobTitle: string | null | undefined;
          readonly advocateName: string | null | undefined;
          readonly advocateQuote: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly callToActionCollection: {
        readonly items: ReadonlyArray<{
          readonly ctaText: string | null | undefined;
          readonly ctaUrl: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly customerCompany: {
        readonly industryCollection: {
          readonly items: ReadonlyArray<{
            readonly industryName: string | null | undefined;
          } | null | undefined>;
        } | null | undefined;
        readonly logoCollection: {
          readonly items: ReadonlyArray<{
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly url: string | null | undefined;
          } | null | undefined>;
        } | null | undefined;
        readonly organizationNameExternal: string | null | undefined;
        readonly organizationSize: {
          readonly companySizeTitleExternal: string | null | undefined;
        } | null | undefined;
        readonly region: {
          readonly regionNameExternal: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly marketplaceAppsCollection: {
        readonly items: ReadonlyArray<{
          readonly title: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly productCollection: {
        readonly items: ReadonlyArray<{
          readonly productNameReference?: {
            readonly productName: string | null | undefined;
          } | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly solutionCollection: {
        readonly items: ReadonlyArray<{
          readonly solutionNameExternal: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly solutionPartnersCollection: {
        readonly items: ReadonlyArray<{
          readonly organizationNameExternal: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly storyIcon: {
        readonly contentType: string | null | undefined;
        readonly description: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
      readonly storyTitleExternal: string | null | undefined;
      readonly sys: {
        readonly publishedAt: any | null | undefined;
      };
      readonly urlSlug: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly productNameCollection: {
    readonly items: ReadonlyArray<{
      readonly linkedFrom: {
        readonly productListingCollection: {
          readonly items: ReadonlyArray<{
            readonly linkedFrom: {
              readonly customerStoryCollection: {
                readonly total: number;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined>;
          readonly total: number;
        } | null | undefined;
      } | null | undefined;
      readonly productName: string | null | undefined;
    } | null | undefined>;
    readonly total: number;
  } | null | undefined;
  readonly taxonomyCompanySizeCollection: {
    readonly items: ReadonlyArray<{
      readonly companySizeTitleExternal: string | null | undefined;
      readonly linkedFrom: {
        readonly companyNameInternalCollection: {
          readonly items: ReadonlyArray<{
            readonly linkedFrom: {
              readonly customerStoryCollection: {
                readonly total: number;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined>;
          readonly total: number;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined>;
    readonly total: number;
  } | null | undefined;
  readonly taxonomyIndustryCollection: {
    readonly items: ReadonlyArray<{
      readonly industryName: string | null | undefined;
      readonly linkedFrom: {
        readonly companyNameInternalCollection: {
          readonly items: ReadonlyArray<{
            readonly linkedFrom: {
              readonly customerStoryCollection: {
                readonly total: number;
              } | null | undefined;
            } | null | undefined;
            readonly organizationNameExternal: string | null | undefined;
          } | null | undefined>;
          readonly total: number;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined>;
    readonly total: number;
  } | null | undefined;
  readonly taxonomyRegionCollection: {
    readonly items: ReadonlyArray<{
      readonly linkedFrom: {
        readonly companyNameInternalCollection: {
          readonly items: ReadonlyArray<{
            readonly linkedFrom: {
              readonly customerStoryCollection: {
                readonly total: number;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined>;
          readonly total: number;
        } | null | undefined;
      } | null | undefined;
      readonly regionNameExternal: string | null | undefined;
    } | null | undefined>;
    readonly total: number;
  } | null | undefined;
  readonly taxonomySolutionCollection: {
    readonly items: ReadonlyArray<{
      readonly linkedFrom: {
        readonly customerStoryCollection: {
          readonly total: number;
        } | null | undefined;
      } | null | undefined;
      readonly solutionNameExternal: string | null | undefined;
    } | null | undefined>;
    readonly total: number;
  } | null | undefined;
};
export type customerLandingPageRelayQuery = {
  response: customerLandingPageRelayQuery$data;
  variables: customerLandingPageRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  }
],
v1 = {
  "kind": "Variable",
  "name": "locale",
  "variableName": "locale"
},
v2 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 200
  },
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "order",
    "value": "sys_publishedAt_DESC"
  },
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "storyTitleExternal_exists": true,
      "sys": {
        "publishedAt_exists": true
      }
    }
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Sys",
  "kind": "LinkedField",
  "name": "sys",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "storyTitleExternal",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationNameExternal",
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "limit",
  "value": 5
},
v7 = [
  (v6/*: any*/)
],
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contentType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "industryName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regionNameExternal",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companySizeTitleExternal",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "CompanyNameInternal",
  "kind": "LinkedField",
  "name": "customerCompany",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": (v7/*: any*/),
      "concreteType": "AssetCollection",
      "kind": "LinkedField",
      "name": "logoCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": (v8/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "logoCollection(limit:5)"
    },
    {
      "alias": null,
      "args": (v7/*: any*/),
      "concreteType": "CompanyNameInternalIndustryCollection",
      "kind": "LinkedField",
      "name": "industryCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyIndustry",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "industryCollection(limit:5)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyRegion",
      "kind": "LinkedField",
      "name": "region",
      "plural": false,
      "selections": [
        (v10/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyCompanySize",
      "kind": "LinkedField",
      "name": "organizationSize",
      "plural": false,
      "selections": [
        (v11/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "CustomerStoryAdvocateQuotesCollection",
  "kind": "LinkedField",
  "name": "advocateQuotesCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdvocateQuote",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "advocateName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "advocateQuote",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "advocateJobTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "advocateHeadshot",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "advocateQuotesCollection(limit:5)"
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "storyIcon",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "CustomerStoryCallToActionCollection",
  "kind": "LinkedField",
  "name": "callToActionCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CallToAction",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "callToActionCollection(limit:5)"
},
v16 = {
  "kind": "Literal",
  "name": "limit",
  "value": 20
},
v17 = [
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productName",
  "storageKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductName",
      "kind": "LinkedField",
      "name": "productNameReference",
      "plural": false,
      "selections": [
        (v18/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ProductListing",
  "abstractKey": null
},
v20 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "CustomerStoryMarketplaceAppsCollection",
  "kind": "LinkedField",
  "name": "marketplaceAppsCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContextApp",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "marketplaceAppsCollection(limit:5)"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "solutionNameExternal",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "CustomerStorySolutionCollection",
  "kind": "LinkedField",
  "name": "solutionCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomySolution",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v21/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "solutionCollection(limit:5)"
},
v23 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "CustomerStorySolutionPartnersCollection",
  "kind": "LinkedField",
  "name": "solutionPartnersCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNameInternal",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "solutionPartnersCollection(limit:5)"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v25 = [
  (v16/*: any*/),
  (v1/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v27 = [
  {
    "kind": "Literal",
    "name": "allowedLocales",
    "value": [
      "en-US",
      "es",
      "ja-JP",
      "pt-BR",
      "fr-FR",
      "de-DE",
      "nl-NL",
      "it-IT",
      "ko-KR",
      "pl-PL",
      "ru-RU",
      "zh-CN"
    ]
  }
],
v28 = [
  (v26/*: any*/)
],
v29 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "limit",
        "value": 1
      }
    ],
    "concreteType": "CustomerStoryCollection",
    "kind": "LinkedField",
    "name": "customerStoryCollection",
    "plural": false,
    "selections": (v28/*: any*/),
    "storageKey": "customerStoryCollection(limit:1)"
  }
],
v30 = {
  "alias": null,
  "args": (v27/*: any*/),
  "concreteType": "CompanyNameInternalLinkingCollections",
  "kind": "LinkedField",
  "name": "linkedFrom",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
},
v31 = {
  "alias": null,
  "args": (v25/*: any*/),
  "concreteType": "TaxonomyIndustryCollection",
  "kind": "LinkedField",
  "name": "taxonomyIndustryCollection",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyIndustry",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v9/*: any*/),
        {
          "alias": null,
          "args": (v27/*: any*/),
          "concreteType": "TaxonomyIndustryLinkingCollections",
          "kind": "LinkedField",
          "name": "linkedFrom",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyNameInternalCollection",
              "kind": "LinkedField",
              "name": "companyNameInternalCollection",
              "plural": false,
              "selections": [
                (v26/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CompanyNameInternal",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    (v5/*: any*/),
                    (v30/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 25
    },
    (v1/*: any*/)
  ],
  "concreteType": "ProductNameCollection",
  "kind": "LinkedField",
  "name": "productNameCollection",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductName",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v18/*: any*/),
        {
          "alias": null,
          "args": (v27/*: any*/),
          "concreteType": "ProductNameLinkingCollections",
          "kind": "LinkedField",
          "name": "linkedFrom",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductListingCollection",
              "kind": "LinkedField",
              "name": "productListingCollection",
              "plural": false,
              "selections": [
                (v26/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductListing",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": (v27/*: any*/),
                      "concreteType": "ProductListingLinkingCollections",
                      "kind": "LinkedField",
                      "name": "linkedFrom",
                      "plural": false,
                      "selections": (v29/*: any*/),
                      "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CompanyNameInternalCollection",
    "kind": "LinkedField",
    "name": "companyNameInternalCollection",
    "plural": false,
    "selections": [
      (v26/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "CompanyNameInternal",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          (v30/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v34 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 10
    },
    (v1/*: any*/)
  ],
  "concreteType": "TaxonomyRegionCollection",
  "kind": "LinkedField",
  "name": "taxonomyRegionCollection",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyRegion",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        {
          "alias": null,
          "args": (v27/*: any*/),
          "concreteType": "TaxonomyRegionLinkingCollections",
          "kind": "LinkedField",
          "name": "linkedFrom",
          "plural": false,
          "selections": (v33/*: any*/),
          "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": (v25/*: any*/),
  "concreteType": "TaxonomySolutionCollection",
  "kind": "LinkedField",
  "name": "taxonomySolutionCollection",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomySolution",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v21/*: any*/),
        {
          "alias": null,
          "args": (v27/*: any*/),
          "concreteType": "TaxonomySolutionLinkingCollections",
          "kind": "LinkedField",
          "name": "linkedFrom",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomerStoryCollection",
              "kind": "LinkedField",
              "name": "customerStoryCollection",
              "plural": false,
              "selections": (v28/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": [
    (v6/*: any*/),
    (v1/*: any*/)
  ],
  "concreteType": "TaxonomyCompanySizeCollection",
  "kind": "LinkedField",
  "name": "taxonomyCompanySizeCollection",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyCompanySize",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        {
          "alias": null,
          "args": (v27/*: any*/),
          "concreteType": "TaxonomyCompanySizeLinkingCollections",
          "kind": "LinkedField",
          "name": "linkedFrom",
          "plural": false,
          "selections": (v33/*: any*/),
          "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "customerLandingPageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CustomerStoryCollection",
        "kind": "LinkedField",
        "name": "customerStoryCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerStory",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "CustomerStoryProductCollection",
                "kind": "LinkedField",
                "name": "productCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "productCollection(limit:20)"
              },
              (v20/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v31/*: any*/),
      (v32/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "customerLandingPageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CustomerStoryCollection",
        "kind": "LinkedField",
        "name": "customerStoryCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerStory",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "CustomerStoryProductCollection",
                "kind": "LinkedField",
                "name": "productCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "productCollection(limit:20)"
              },
              (v20/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v31/*: any*/),
      (v32/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/)
    ]
  },
  "params": {
    "cacheID": "3d3404ffc84351b24b67ea30bba4dc60",
    "id": null,
    "metadata": {},
    "name": "customerLandingPageRelayQuery",
    "operationKind": "query",
    "text": "query customerLandingPageRelayQuery(\n  $locale: String!\n) {\n  customerStoryCollection(locale: $locale, limit: 200, order: sys_publishedAt_DESC, where: {sys: {publishedAt_exists: true}, storyTitleExternal_exists: true}) {\n    items {\n      sys {\n        publishedAt\n      }\n      storyTitleExternal\n      customerCompany {\n        organizationNameExternal\n        logoCollection(limit: 5) {\n          items {\n            description\n            contentType\n            url\n          }\n        }\n        industryCollection(limit: 5) {\n          items {\n            industryName\n          }\n        }\n        region {\n          regionNameExternal\n        }\n        organizationSize {\n          companySizeTitleExternal\n        }\n      }\n      advocateQuotesCollection(limit: 5) {\n        items {\n          advocateName\n          advocateQuote\n          advocateJobTitle\n          advocateHeadshot {\n            description\n            contentType\n            url\n          }\n        }\n      }\n      storyIcon {\n        description\n        contentType\n        url\n      }\n      callToActionCollection(limit: 5) {\n        items {\n          ctaText\n          ctaUrl\n        }\n      }\n      productCollection(limit: 20) {\n        items {\n          __typename\n          ... on ProductListing {\n            productNameReference {\n              productName\n            }\n          }\n        }\n      }\n      marketplaceAppsCollection(limit: 5) {\n        items {\n          title\n        }\n      }\n      solutionCollection(limit: 5) {\n        items {\n          solutionNameExternal\n        }\n      }\n      solutionPartnersCollection(limit: 5) {\n        items {\n          organizationNameExternal\n        }\n      }\n      urlSlug\n    }\n  }\n  taxonomyIndustryCollection(locale: $locale, limit: 20) {\n    total\n    items {\n      industryName\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            organizationNameExternal\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  productNameCollection(locale: $locale, limit: 25) {\n    total\n    items {\n      productName\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        productListingCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  taxonomyRegionCollection(locale: $locale, limit: 10) {\n    total\n    items {\n      regionNameExternal\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  taxonomySolutionCollection(locale: $locale, limit: 20) {\n    total\n    items {\n      solutionNameExternal\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        customerStoryCollection {\n          total\n        }\n      }\n    }\n  }\n  taxonomyCompanySizeCollection(locale: $locale, limit: 5) {\n    total\n    items {\n      companySizeTitleExternal\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "14e2d83e9b74bfe20f118ae09eb3c78c";

export default node;
